import { currencies } from "../constants";

/**
 * Format a numeric amount with an optional currency symbol.
 * e.g. formatMoney(2450300, "₦") -> "₦ 2,450,300"
 */
export function formatMoney(amount: number, symbol = ""): string {
  const value = Number.isFinite(amount) ? amount : 0;
  const formatted = value.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return `${symbol} ${formatted}`.trim();
}

/**
 * Derive the flag emoji for a currency code from the `currencies` constant
 * (labels look like "🇳🇬 NGN"). Returns "" when no match is found.
 */
export function getCurrencyFlag(currencyCode: string): string {
  const match = currencies.find((item) => item.value === currencyCode);
  if (!match) return "";
  // Label format: "<flag> <CODE>" — take the leading flag glyph(s).
  return match.label.split(" ")[0] ?? "";
}
